// TODO: Este es un provider de jobs
import React, { createContext } from 'react';
import { PropTypes } from 'prop-types';
import { Pagination } from './Helpers/Pagination';
import { Filtros } from './Helpers/Filtros';
import { Search } from './Helpers/BarSearch';

export const ContextJobs = createContext();

const JobsProvider = ({ children }) => {
  const { pagination, changedPagination } = Pagination();

  const { state, searchEncargadoFunction, handleStatusFilterChange, setJobs, reset } = Filtros();

  const { text, changedText } = Search({ setJobs, changedPagination });

  const value = {
    pagination,
    changedPagination,
    state,
    searchEncargadoFunction,
    handleStatusFilterChange,
    text,
    changedText,
    reset,
  };

  return <ContextJobs.Provider value={value}>{children} </ContextJobs.Provider>;
};

JobsProvider.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any,
};

JobsProvider.defaultProps = {
  children: <div />,
};

function useJob() {
  const context = React.useContext(ContextJobs);
  if (!context) {
    throw new Error('El provider Email Magic ha fallado');
  }
  return context;
}

export { JobsProvider, useJob };
